export default __webpack_public_path__ + "static/media/Tech_Hub_SFL.0b66e695.svg";